import { render, staticRenderFns } from "./ConsultaComprobante.vue?vue&type=template&id=590bca54"
import script from "./ConsultaComprobante.vue?vue&type=script&lang=js"
export * from "./ConsultaComprobante.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports